import { NgModule } from "@angular/core";
import { FormatCardNumberPipe, FormatPhoneNumberPipe } from "../pipe/pipes";
import { FormatterServiceImpl } from "./service/formatter.service.impl";
import { FormatterServiceToken } from "./service/formatter.service";
import { FormatterService } from "./service/formatter.service";
import { FormatterServiceConfig, FormatterServiceConfigToken } from "./model/formatter.service.config.model";
import { CommonModule, DatePipe } from "@angular/common";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    FormatCardNumberPipe,
    FormatPhoneNumberPipe
  ],
  exports: [
    FormatCardNumberPipe,
    FormatPhoneNumberPipe
  ],
  providers: [
    DatePipe,
    FormatCardNumberPipe,
    FormatPhoneNumberPipe,
    {provide: FormatterServiceToken, useClass: FormatterServiceImpl}
  ]
})
class FormatterModule {
}

export {
  FormatterModule,
  FormatCardNumberPipe,
  FormatPhoneNumberPipe,
  FormatterServiceConfig,
  FormatterServiceConfigToken,
  FormatterService,
  FormatterServiceToken,
  FormatterServiceImpl
};
